import { scheduleOnce } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import type LocationModel from 'garaje/models/location';
import type FlashMessagesService from 'garaje/services/flash-messages';
import { parseErrorForDisplay } from 'garaje/utils/flash-promise';
import iframeWriteDoc from 'garaje/utils/iframe-write-doc';

interface VisitorEmailsWelcomeEmailWePreviewingComponentSignature {
  Args: {
    location: LocationModel;
  };
}

export default class VisitorEmailsWelcomeEmailWePreviewingComponent extends Component<VisitorEmailsWelcomeEmailWePreviewingComponentSignature> {
  @service declare flashMessages: FlashMessagesService;

  @tracked previewHTML?: string;
  @tracked subject?: string;

  constructor(owner: unknown, args: VisitorEmailsWelcomeEmailWePreviewingComponentSignature['Args']) {
    super(owner, args);
    void this.loadWelcomeEmailPreviewHTMLTask.perform();
  }

  loadWelcomeEmailPreviewHTMLTask = task(async () => {
    try {
      const {
        data: {
          attributes: { body, subject },
        },
      } = await this.args.location.getWelcomeEmailPreview();
      this.previewHTML = body;
      this.subject = subject;
      scheduleOnce('afterRender', this, iframeWriteDoc, 'email-iframe', this.previewHTML);
    } catch (e) {
      const errorText = parseErrorForDisplay(e);
      this.flashMessages.showAndHideFlash('error', errorText);
    }
  });
}
